import React from "react";

import type { AddressSignedAuthorization } from "types/api/address";

import { AddressHighlightProvider } from "lib/contexts/addressHighlight";
import {
  TableBody,
  TableColumnHeader,
  TableHeaderSticky,
  TableRoot,
  TableRow,
} from "toolkit/chakra/table";

import AddressAuthorizationsTableItem from "./AddressAuthorizationsTableItem";

interface Props {
  data: Array<AddressSignedAuthorization> | undefined;
  isLoading?: boolean;
}

const AddressAuthorizationsTable = ({ data, isLoading }: Props) => {
  return (
    <AddressHighlightProvider>
      <TableRoot>
        <TableHeaderSticky>
          <TableRow>
            <TableColumnHeader width="30%">Address</TableColumnHeader>
            <TableColumnHeader width="30%">Authority</TableColumnHeader>
            <TableColumnHeader width="100px">Chain</TableColumnHeader>
            <TableColumnHeader width="120px" isNumeric>
              Nonce
            </TableColumnHeader>
            <TableColumnHeader width="160px" isNumeric>
              Status
            </TableColumnHeader>
          </TableRow>
        </TableHeaderSticky>
        <TableBody>
          {data?.map((item, index) => (
            <AddressAuthorizationsTableItem
              key={`${item.nonce}-${index}`}
              {...item}
              isLoading={isLoading}
            />
          ))}
        </TableBody>
      </TableRoot>
    </AddressHighlightProvider>
  );
};

export default AddressAuthorizationsTable;
